import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
const ContactCampaignCardAction = ({
  assetId
}) => {
  const sendOpenEditCampaignsPanel = useSendCrmMessageTopic(TOPIC_NAMES.OPEN_EDIT_CAMPAIGN_ENGAGEMENT_MODAL);
  const handleAddCampaign = () => {
    sendOpenEditCampaignsPanel({
      contactId: assetId
    });
  };
  return /*#__PURE__*/_jsx(Button, {
    use: "link",
    onClick: handleAddCampaign,
    "data-test-id": "campaign-add-button",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "cardAssociatedObjects.addAssociationButton"
    })
  });
};
export default ContactCampaignCardAction;